import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import {
  formatDateTimeStamp,
  getInitalDateRangeForListData,
  isLargeScreen,
  isLargeScreenFun,
} from '../../../../global.variable';
import { ModalDialogueService } from '../../../shared/components/modal-dialogue/modal-dialogue.service';
import { OrientationLockService } from '../../../shared/services/orientationlock.service';
import { ToasterService } from '../../../shared/services/toaster.service';
import { WebSocketService } from '../../../shared/services/web-socket.service';
import { getDateTimeRange } from '../tableDetails';
import { AddEditUserComponent } from '../users/add-edit-user/add-edit-user.component';
import { UsersService } from '../users/users.service';

@Component({
  selector: 'gtapp-sos-welfare-checks',
  templateUrl: './sos-welfare-checks.component.html',
  styleUrl: './sos-welfare-checks.component.scss',
  standalone: false,
})
export class SosWelfareChecksComponent {
  //missed welfare check data variables
  totalRowsMissedWelfareCheck: number = 0;
  previousMissedWelfareCheck: number = 0;
  pageSizeMissedWelfareCheck: number = 10;
  pageNumMissedWelfareCheck: number = 1;
  totalPagesMissedWelfareCheck: number = 0;
  searchParamsMissedWelfareCheck: any;
  sortKeysMissedWelfareCheck: any = ['-updated_at'];
  dateRangeMissedWelfareCheck: any;

  otherParamsMissedWelfareCheck: any = {};
  lastUpdatedDetails: any = {};
  missedWelfareData: any;
  tableDetailMissedWelfareCheck = [
    {
      header: 'Check Time',
      name: 'updated_at',
      datetimeObj: true,
      dateRangeKey: 'updated_at',
      sortKey: 'updated_at',
      default: true,
      ...getDateTimeRange(),
    },

    {
      header: 'Status',

      nestedValue: (row: any) => {
        if (row?.missed_welfare_check_id && row?.welfare_checked_id) {
          // late check in
          const details = [`MISSED`];
          // if (row?.welfare_checked_updated_at) {
          //   details.push(
          //     `${formatDateTimeStamp(
          //       row?.welfare_checked_updated_at,
          //       'd MMM y HH:mm',
          //       'en_US'
          //     )}`
          //   );
          // }

          return details.join('\n');
        }
        if (!row?.missed_welfare_check_id && row?.welfare_checked_id) {
          const details = [];
          if (row?.welfare_checked_updated_at) {
            details.push(
              `${formatDateTimeStamp(
                row?.welfare_checked_updated_at,
                'd MMM y HH:mm',
                'en_US',
              )}`,
            );
          }

          return details.join('\n');
        }

        return `MISSED`;
      },
      conditionalColumnDataStyle: (row: any) => {
        if (row?.missed_welfare_check_id && row?.welfare_checked_id) {
          // late check in
          return {
            'color': 'var(--bs-white)',
            'background-color': 'var(--bs-danger)',
            'border': '1px solid',
            'border-radius': '5px',
            'padding': '0 0.5rem',
            'white-space': 'pre-line',
            'display': 'flex',
            'font-size': 'small',
            'text-align': 'center',
            'align-items': 'center',
            'justify-content': 'center',
          };
        }
        if (!row?.missed_welfare_check_id && row?.welfare_checked_id) {
          return {
            'color': 'var(--bs-white)',
            'background-color': 'var(--bs-success)',
            'border': '1px solid',
            'border-radius': '5px',
            'padding': '0 0.5rem',
            'white-space': 'pre-line',
            'display': 'flex',
            'font-size': 'small',
            'text-align': 'center',
            'align-items': 'center',
            'justify-content': 'center',
          };
        }
        // check in due
        return {
          'color': 'var(--bs-white)',
          'background-color': 'var(--bs-danger)',
          'border': '1px solid',
          'border-radius': '5px',
          'padding': '0 0.5rem',
          'white-space': 'pre-line',
          'display': 'flex',
          'font-size': 'small',
          'text-align': 'center',
          'align-items': 'center',
          'justify-content': 'center',
        };
      },
    },
    {
      header: '',
      columnDataStyle: {
        'white-space': 'pre-line',
      },
      nestedValue: (row: any) => {
        const details: any = [];
        if (row?.missed_welfare_check_id && row?.welfare_checked_id) {
          // late check in
          const details = [];
          if (row?.missed_welfare_check_reason) {
            details.push(`Reason: ${row?.missed_welfare_check_reason}`);
          } else {
            details.push(`[Reason not provided]`);
          }
          return details.join('\n');
        }

        // if (row?.missed_welfare_check_missed_at) {
        //   details.push(
        //     `Missed At: ${formatDateTimeStamp(
        //       row?.missed_welfare_check_missed_at,
        //       'd MMM y HH:mm',
        //       'en_US'
        //     )}`
        //   );
        // }
        // if (this.lastUpdatedDetails?.[row?.user_id]) {
        //   // const userLastUpdate = this.lastUpdatedDetails?.[row?.user_id];
        //   // details.push(
        //   //   `Last Update: ${userLastUpdate?.action} | ${formatDateTimeStamp(
        //   //     userLastUpdate?.updated_at,
        //   //     'd MMM y HH:mm',
        //   //     'en_US'
        //   //   )}`
        //   // );
        // }
        return details.join('\n');
      },
    },
    {
      header: 'User',
      name: 'user_name',
      searchKey: 'user_name',
      sortKey: 'user_name',
    },
  ];
  mobileDetailMissedWelfareCheck = {
    individualDetails: [
      {
        nestedValue: (row: any) => {
          if (row?.missed_welfare_check_id && row?.welfare_checked_id) {
            // late check in
            const details = [`MISSED`];
            // if (row?.welfare_checked_updated_at) {
            //   details.push(
            //     `${formatDateTimeStamp(
            //       row?.welfare_checked_updated_at,
            //       'd MMM y HH:mm',
            //       'en_US'
            //     )}`
            //   );
            // }

            return details.join('\n');
          }
          if (!row?.missed_welfare_check_id && row?.welfare_checked_id) {
            const details = [];
            if (row?.welfare_checked_updated_at) {
              details.push(
                `${formatDateTimeStamp(
                  row?.welfare_checked_updated_at,
                  'd MMM y HH:mm',
                  'en_US',
                )}`,
              );
            }

            return details.join('\n');
          }

          return `MISSED`;
        },
        conditionalRowStyle: (row: any) => {
          if (row?.missed_welfare_check_id && row?.welfare_checked_id) {
            // late check in
            return {
              'color': 'var(--bs-white)',
              'background-color': 'var(--bs-danger)',
              'border': '1px solid',
              'border-radius': '5px',
              'padding': '0 0.5rem',
              'white-space': 'pre-line',
              'display': 'flex',
              'font-size': 'small',
              'text-align': 'center',
              'align-items': 'center',
              'justify-content': 'center',
              'float': 'right',
            };
          }
          if (!row?.missed_welfare_check_id && row?.welfare_checked_id) {
            return {
              'color': 'var(--bs-white)',
              'background-color': 'var(--bs-success)',
              'border': '1px solid',
              'border-radius': '5px',
              'padding': '0 0.5rem',
              'white-space': 'pre-line',
              'display': 'flex',
              'font-size': 'small',
              'text-align': 'center',
              'align-items': 'center',
              'justify-content': 'center',
              'float': 'right',
            };
          }

          return {
            'color': 'var(--bs-white)',
            'background-color': 'var(--bs-danger)',
            'border': '1px solid',
            'border-radius': '5px',
            'padding': '0 0.5rem',
            'white-space': 'pre-line',
            'display': 'flex',
            'font-size': 'small',
            'text-align': 'center',
            'align-items': 'center',
            'justify-content': 'center',
            'float': 'right',
          };
        },
      },

      {
        name: 'updated_at',
        prefix: 'Requested: ',
        dateRangeKey: 'updated_at',
        ...getDateTimeRange(),
        datetimeObj: true,
        cardRowStyle: {
          'font-size': 'small',
        },
      },
      {
        name: 'user_name',
        cardRowStyle: {
          'font-size': 'small',
          'font-weight': 'bold',
        },
      },
      {
        rowDataStyle: {
          'white-space': 'pre-line',
        },
        nestedValue: (row: any) => {
          const details: any = [];
          if (row?.missed_welfare_check_id && row?.welfare_checked_id) {
            // late check in
            const details = [];
            if (row?.missed_welfare_check_reason) {
              details.push(`Reason: ${row?.missed_welfare_check_reason}`);
            } else {
              details.push(`[Reason not provided]`);
            }
            return details.join('\n');
          }

          // if (row?.missed_welfare_check_missed_at) {
          //   details.push(
          //     `Missed At: ${formatDateTimeStamp(
          //       row?.missed_welfare_check_missed_at,
          //       'd MMM y HH:mm',
          //       'en_US'
          //     )}`
          //   );
          // }
          // if (this.lastUpdatedDetails?.[row?.user_id]) {
          //   const userLastUpdate = this.lastUpdatedDetails?.[row?.user_id];
          //   details.push(
          //     `Last Update: ${userLastUpdate?.action} | ${formatDateTimeStamp(
          //       userLastUpdate?.updated_at,
          //       'd MMM y HH:mm',
          //       'en_US'
          //     )}`
          //   );
          // }
          return details.join('\n');
        },
      },
    ],
  };

  largeView: Boolean = isLargeScreen;
  isLargeScreenSubscription: Subscription = new Subscription();

  webSocketSubscription: any;
  routeSubscription: any;

  newEventsAvailable: boolean = false;

  uiTabs = {
    tab1: 'Welfare',
    tab2: 'Logs',
    tab3: 'SOS Alerts',
  };
  activeTab = this.uiTabs.tab1;

  constructor(
    private userService: UsersService,
    private route: ActivatedRoute,
    private toasterService: ToasterService,
    private orientationService: OrientationLockService,
    private dialogService: ModalDialogueService,
    private webSocketService: WebSocketService,
  ) {}

  ngOnDestroy() {
    this.isLargeScreenSubscription?.unsubscribe();
    if (this.webSocketSubscription) {
      this.webSocketSubscription?.unsubscribe();
    }
    if (this.routeSubscription) {
      this.routeSubscription?.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.routeSubscription = this.route.params.subscribe({
      next: (params: any) => {
        const alertCounts = Number(params?.alertCounts);

        if (this.route.snapshot.fragment === 'welfareChecks') {
          this.changeTab(this.uiTabs.tab1);
        } else if (
          alertCounts > 0 ||
          this.route.snapshot.fragment === 'sosAlerts'
        ) {
          this.changeTab(this.uiTabs.tab3);
        }
      },
    });
    this.isLargeScreenSubscription =
      this.orientationService.isLargeScreen.subscribe(async (event: any) => {
        if (event) {
          this.largeView = await isLargeScreenFun();
        }
      });
    this.webSocketSubscription =
      this.webSocketService.webSocketSubject.subscribe((event: any) => {
        if (
          event?.event === 'welfare_check_in_update' &&
          this.activeTab === this.uiTabs.tab1
        ) {
          this.getMissedWelfareCheckData(true);
        }
      });

    this.dateRangeMissedWelfareCheck = getInitalDateRangeForListData(
      this.mobileDetailMissedWelfareCheck?.individualDetails || [],
    );
  }
  changeTab(event: any) {
    if (!Object.values(this.uiTabs)?.includes(event)) {
      event = this.uiTabs.tab1;
    }

    if (event === this.uiTabs.tab2) {
      this.getMissedWelfareCheckData();
    }
    this.activeTab = event;
  }
  getMissedWelfareCheckData(autoUpdate = false) {
    let body: any = {
      event_type: 'welfare_checks',
    };
    if (this.dateRangeMissedWelfareCheck)
      body.date_range = this.dateRangeMissedWelfareCheck;

    if (this.sortKeysMissedWelfareCheck)
      body.sort_key = this.sortKeysMissedWelfareCheck;

    if (this.searchParamsMissedWelfareCheck)
      body.search_filters = this.searchParamsMissedWelfareCheck;

    if (this.pageSizeMissedWelfareCheck) {
      body['rows'] = this.pageSizeMissedWelfareCheck;
    }
    if (this.previousMissedWelfareCheck) {
      body['previous'] = this.previousMissedWelfareCheck;
    }

    this.userService.getUserUpdateLog(body).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.missedWelfareData = response['data'];
        this.lastUpdatedDetails = response?.last_update_data || {};
        this.newEventsAvailable =
          autoUpdate && response?.total_size > this.totalRowsMissedWelfareCheck;
        this.totalRowsMissedWelfareCheck = response['total_size'];

        this.totalPagesMissedWelfareCheck = Math.ceil(
          this.totalRowsMissedWelfareCheck / this.pageSizeMissedWelfareCheck,
        );
        this.otherParamsMissedWelfareCheck = {
          paginationData: {
            totalRows: this.totalRowsMissedWelfareCheck,
            previousRows: this.previousMissedWelfareCheck,
            rows: this.pageSizeMissedWelfareCheck,
            pageNum: this.pageNumMissedWelfareCheck,
            totalPages: this.totalPagesMissedWelfareCheck,
          },
        };
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
      }
    });
  }

  onChangePaginationMissedWelfareCheck(data: any) {
    this.previousMissedWelfareCheck = data?.paginationData?.previousRows;
    this.pageNumMissedWelfareCheck = data?.paginationData?.pageNum;
    this.pageSizeMissedWelfareCheck = data?.paginationData?.rows;

    this.getMissedWelfareCheckData();

    this.otherParamsMissedWelfareCheck.paginationData = {
      ...data?.paginationData,
    };
  }
  sortColumnMissedWelfareCheck(sortData: any) {
    this.resetPagenMissedWelfareCheck();
    this.sortKeysMissedWelfareCheck = sortData?.sortList || [];
    this.getMissedWelfareCheckData();
  }

  searchColumnMissedWelfareCheck(searchData: any) {
    this.resetPagenMissedWelfareCheck();
    this.dateRangeMissedWelfareCheck = null;
    this.searchParamsMissedWelfareCheck = searchData?.searchParams || {};

    this.getMissedWelfareCheckData();
  }
  resetPagenMissedWelfareCheck() {
    this.totalRowsMissedWelfareCheck = 0;
    this.previousMissedWelfareCheck = 0;
    this.pageSizeMissedWelfareCheck = 10;
    this.pageNumMissedWelfareCheck = 1;
    this.totalPagesMissedWelfareCheck = 0;
    this.otherParamsMissedWelfareCheck.paginationData = {
      totalRows: this.totalRowsMissedWelfareCheck,
      previousRows: this.previousMissedWelfareCheck,
      rows: this.pageSizeMissedWelfareCheck,
      pageNum: this.pageNumMissedWelfareCheck,
      totalPages: this.totalPagesMissedWelfareCheck,
    };
  }
  openUserDetailTemplate(eventData: any) {
    if (eventData?.subs_user_id) {
      this.dialogService.open(AddEditUserComponent, {
        data: {
          editUser: true,
          detailData: { id: eventData.subs_user_id },
        },
      });
    }
  }
}
